export default __webpack_public_path__ + "static/media/avatar_siti7.caa30795.mp3";